var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 20,
    cy: 20,
    r: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-4---Inbox",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.11--Elements",
    transform: "translate(-2172.000000, -1063.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(2172.000000, 1063.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Photo",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Photo",
    fillOpacity: 0.3,
    fill: "#F86B67",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,22 C19.4477153,22 19,22.4477153 19,23 C19,23.5522847 19.4477153,24 20,24 C20.5522847,24 21,23.5522847 21,23 C21,22.4477153 20.5522847,22 20,22 Z M30.5828841,23.4853788 L22.5798408,9.53335778 C22.0530964,8.58670434 21.0564609,8 19.9751236,8 C18.8937863,8 17.8971507,8.58670434 17.3704063,9.53335778 L9.41707135,23.4853788 C8.872318,24.4063355 8.86044361,25.548996 9.38593986,26.4811286 C9.91143612,27.4132611 10.8940684,27.9925444 11.9621385,27.9998542 L27.9881086,27.9998542 C29.0650624,28.0104931 30.0640836,27.438279 30.6017527,26.5028248 C31.1394217,25.5673706 31.1322095,24.4140029 30.5828841,23.4853788 Z M28.8846129,25.4916837 C28.7073752,25.808234 28.3726548,26.0029647 28.0109323,25.9999659 L12.0066931,25.9999659 C11.6449706,26.0029647 11.3102502,25.808234 11.1330125,25.4916837 C10.9556625,25.1833247 10.9556625,24.8034108 11.1330125,24.4950519 L19.075563,10.542207 C19.2454303,10.2093657 19.5866235,10 19.9591718,10 C20.33172,10 20.6729132,10.2093657 20.8427805,10.542207 L28.834972,24.4950519 C29.0356254,24.7992436 29.054667,25.1891828 28.8846129,25.5116163 L28.8846129,25.4916837 Z M20,14 C19.4477153,14 19,14.4477153 19,15 L19,19 C19,19.5522847 19.4477153,20 20,20 C20.5522847,20 21,19.5522847 21,19 L21,15 C21,14.4477153 20.5522847,14 20,14 Z",
    id: "Shape",
    fill: "#F86B67",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/Request.7138e2641243d673f493f895013f6eac.svg";
export { ForwardRef as ReactComponent };